module.exports = __webpack_public_path__ + "img/features_hero_mobile.0b3622a8.jpg";